import { ROLE_ADMIN, ROLE_MEMBER, ROLE_MODERATOR, ROLE_NONE, ROLE_OWNER, } from "@shared";
export function hasOwnerRights(role) {
    return role === ROLE_OWNER;
}
export function isPermitted(role, permissionRole) {
    if (role === ROLE_NONE || permissionRole === ROLE_NONE)
        return false;
    return role >= permissionRole;
}
export function roleAsText(role) {
    switch (role) {
        case ROLE_OWNER:
            return "owner";
        case ROLE_ADMIN:
            return "admin";
        case ROLE_MODERATOR:
            return "moderator";
        case ROLE_MEMBER:
            return "member";
        default:
            return "none";
    }
}
